export default __webpack_public_path__ + "c3c3de34cbed5bea0f4c1547c14f9e7e.png";